// components/DocketTable.jsx
import React from 'react';
import { Table } from 'antd';

const DocketTable = ({ dockets, columns, tableHeight, containerRef }) => (
  <div style={{ padding: 10 }} ref={containerRef}>
    <Table
      className="list-data"
      dataSource={dockets}
      columns={columns}
      pagination={false}
      scroll={{ y: tableHeight, x: 'max-content' }}
      rowKey="id"
    />
  </div>
);

export default DocketTable;